import React from "react";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8 animate-fade-up">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-stone-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-stone-500 mt-1.5">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, accent = "emerald", sub }) {
  const tones = {
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-600",
    blue: "bg-blue-50 text-blue-600",
    stone: "bg-stone-100 text-stone-600",
  };
  return (
    <div className="bg-white border border-stone-200 rounded-2xl p-5 shadow-sm hover:shadow-md transition-all">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-widest text-stone-400">{label}</p>
        <span className={`w-9 h-9 rounded-xl flex items-center justify-center ${tones[accent]}`}>
          {Icon && <Icon size={18} />}
        </span>
      </div>
      <p className="font-heading text-2xl md:text-[1.7rem] font-bold text-stone-900 mt-3 leading-tight">{value}</p>
      {sub && <p className="text-xs text-stone-400 mt-1">{sub}</p>}
    </div>
  );
}

const STATUS = {
  paid: { t: "Lunas", c: "bg-emerald-100 text-emerald-700" },
  partial: { t: "Cicilan", c: "bg-amber-100 text-amber-700" },
  unpaid: { t: "Belum Bayar", c: "bg-rose-100 text-rose-700" },
  pending: { t: "Menunggu", c: "bg-amber-100 text-amber-700" },
  approved: { t: "Disetujui", c: "bg-emerald-100 text-emerald-700" },
  expired: { t: "Kadaluarsa", c: "bg-stone-200 text-stone-600" },
  cancelled: { t: "Dibatalkan", c: "bg-rose-100 text-rose-600" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || { t: status, c: "bg-stone-100 text-stone-600" };
  return <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.c}`}>{s.t}</span>;
}

export function Empty({ children }) {
  return <div className="text-center py-16 text-stone-400 text-sm">{children}</div>;
}
